import React from 'react'

function FaceBookLogIn() {
    return (
        <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-blue-600 border-2 border-blue-600 hover:bg-blue-600 
              hover:text-white font-normal text-center px-4 py-2 md:px-6 md:py-2 
                rounded-full transition-colors duration-300 text-sm md:text-base"
        >
            Facebook
        </a>
    )
}

export default FaceBookLogIn